module.exports = __webpack_public_path__ + "static/CRMasterpieceStill-46ceac1b5beeb06d142b89de23444650.jpg";